export const routes = {
  explorer: '/explorer',
  approvedFiles: '/explorer/approved-files',
  templates: '/explorer/templates',
  bin: '/explorer/bin',
  folder: (id: string) => `/explorer/${id}`,
  file: (id: string) => `/files/${id}`,
};
